import React from "react";
import { useEffect, useState } from "react";

const Health = () => {
    return <>{`{"status":"up"}`}</>
}

export default Health;